'use client'

// src/utils/utm.ts
import { getItem, safeParseJson } from "@wbk/utils";
var getAnalyticsUtms = () => {
  if (typeof window !== "undefined") {
    const search = new URLSearchParams(window.location.search);
    const utm_source = search.get("utm_source");
    const utm_medium = search.get("utm_medium");
    const utm_campaign = search.get("utm_campaign");
    const utm_wid = search.get("wid");
    const utm_wbk_wa_session_id = getItem("utm_wbk_wa_session_id");
    const utm_id = search.get("utm_id");
    const utm_content = search.get("utm_content");
    const utm_term = search.get("utm_term");
    const validUtms = utm_source && utm_medium || !!utm_wid;
    if (validUtms) {
      return {
        utm_source,
        utm_medium,
        utm_campaign,
        utm_wid,
        utm_wbk_wa_session_id,
        utm_id,
        utm_content,
        utm_term
      };
    }
  }
};
var getAnalyticsUtmsFromStorage = () => {
  if (typeof window !== "undefined") {
    const savedUtms = getItem("utms");
    return savedUtms ? safeParseJson(savedUtms) : null;
  }
};

export {
  getAnalyticsUtms,
  getAnalyticsUtmsFromStorage
};
//# sourceMappingURL=chunk-67IEIQJX.mjs.map